
<template lang="pug">
q-page.fit
  .absolute-full.column

    //- ツールバー
    .col-auto
      .flex.justify-between.q-ma-xs
        .flex.items-center

          //- 個人の追加
          q-btn.q-mx-sm(
            flat
            @click="detailShow()"
          ) 追加

    //- グリッド
    .col.grid
      .grid__table(
        v-show="showGrid"
        ref="table"
        :style="gridTableStyle"
        @mousedown.left.stop="onMouseDownLeft"
      )
        .grid__thead

          //- コーナー
          .grid__corner-area(@contextmenu.prevent)
            .grid__tr
              .grid__corner(:style="gridCornerStyle")

          //- 列ヘッダ
          .grid__column-header-area(@contextmenu.prevent)
            .grid__column-header-cursor(:style="gridColumnHeaderCursorStyle")
            grid-columns(
              :grid="grid"
              :cols="cols"
            )

        .grid__row-area

          //- 行ヘッダ
          .grid__row-header-area(
            @contextmenu.prevent
            @dblclick="onRowHeaderDoubleClick"
          )
            .grid__row-header-cursor(:style="gridRowHeaderCursorStyle")
            .grid__tr(v-for="row of rows")
              .grid__row-header.grid__left(:style="gridRowHeaderStyle") {{row.text}}

          //- セル
          .grid__cell-area(
            @dblclick="onCellDoubleClick"
            @mousedown.left.stop="onCellMouseDownLeft"
          )
            .grid__cell-cursor(:style="gridCellCursorStyle")
            grid-cells(
              :grid="grid"
              :rows="rows"
            )

            ContextMenu2(@beforeShow="onCellContext")

  //- 出退勤時間の入力
  PopupTimeRange(
    ref="popupTimeRange"
    :min="store.display_begin_time"
    :max="store.display_end_time"
    @confirm="timeRangeConfirm"
  )
    q-btn.q-mx-sm(
      color="negative"
      flat
      @click="deleteTime"
    ) 削除

  //- 個人の入力
  WeeklyTaskDetail(
    ref="detail"
    @confirm="detailConfirm"
    @delete="detailDelete"
  )

</template>

<script>
import {timeIsValid, timeFilter, weeks} from 'helpers/date'
import {mapAuto} from 'helpers/vuex-bind'

import PopupTimeRange from 'components/PopupTimeRange'
import WeeklyTaskDetail from './WeeklyTaskDetail'
import AxiosMixin from 'mixins/axios'
import GridMixin from 'mixins/GridMixin'

export default {
  components: {PopupTimeRange, WeeklyTaskDetail},
  mixins: [AxiosMixin, GridMixin],

  props: {
    storeCode: String,
    floorCode: String,
  },

  data() {
    return {
      grid: {
        cellW:    80,
        cellH:    25,
        headerW:  80,
        headerH:  25,
        paddingW: 20,
        paddingH: 20,
      },

      weekly_tasks: [],
      people: [],
      tasks: [],

      clipboard: {},
    }
  },

  computed: {
    ...mapAuto(['stores']),

    viewKey() {
      return Object.values(this.$props).some(v => v == null)
        ? null
        : this.storeCode + '/' + this.floorCode
    },

    store() {
      return this.stores.find(store =>
        store.store_code == this.storeCode &&
        store.floor_code == this.floorCode) || {}
    },

    cols() {
      return [
        {
          text: '割当',
          type: 'Task',
        },
        ...weeks.slice(0, 7).map((v, week) => ({
          text: v.long,
          style: {color: v.color},
          type: 'Time',
          week,
        }))
      ]
    },

    personMap() {
      return Object.fromEntries(this.people.map((v) => [v.person_code, v]))
    },

    taskMap() {
      return Object.fromEntries(this.tasks.map((v) => [v.task_code, v.name]))
    },

    rows() {
      const rows = []
      for (const weekly_task of this.weekly_tasks) {
        rows.push({
          id: weekly_task.id,
          text: this.personMap[weekly_task.person_code].name,
          cells: [
            {text: this.taskMap[weekly_task.task_code]},
            ...weeks.slice(0, 7).map((v, x) => {
              const begin = weekly_task['begin_time_' + x]
              const end = weekly_task['end_time_' + x]
              return {
                text: timeIsValid(begin, end)
                  ? timeFilter(begin) + '〜' + timeFilter(end)
                  : '-',
              }
            }),
          ],
        })
      }
      return rows
    },

  },

  watch: {
    viewKey() {
      this.refresh()
    },
  },

  mounted() {
    this.refresh()
  },

  methods: {

    async refresh(id) {
      try {
        if(this.viewKey != null) {

          // 表示を一旦クリアする
          this.weekly_tasks = []
          this.people = []
          this.tasks = []
          if (id == null) this.grid.cursor = {x: 0, y: 0}

          //
          const {data} = await this.axios.get('/api/weekly_tasks/view/' + this.viewKey)
          this.weekly_tasks = data.weekly_tasks
          this.people = data.people
          this.tasks = data.tasks

          //
          if (id != null) {
            for (const [y, weekly_task] of Object.entries(this.weekly_tasks)) {
              if (id == weekly_task.id) {
                this.grid.cursor.y = y
                break
              }
            }
          }
        }
      }
      catch(e) {this.$handler(e)}
    },

    async createWeeklyTask(weekly_task) {
      const { data } = await this.axios.post('/api/weekly_tasks', {
        ...weekly_task,
        store_code: this.storeCode,
        floor_code: this.floorCode,
      })
      await this.refresh(data.id)
    },

    async updateWeeklyTask(weekly_task, y) {
      const orig = this.weekly_tasks[y]
      const diff = Object.entries(weekly_task).reduce((a, [k, v]) => ({...a, ...v !== orig[k] ? {[k]: v} : {}}), {})
      if(Object.keys(diff).length !== 0) {
        const {data} = await this.axios.put('/api/weekly_tasks/' + weekly_task.id, diff)
        this.$set(this.weekly_tasks, y, data)
        await this.refresh(weekly_task.id)
      }
    },

    async destoryWeeklyTask(data) {
      await this.axios.delete('/api/weekly_tasks/' + data.id)
      await this.refresh()
    },

    //-------------------------------------------------------------------------

    // 左クリックでセルの選択、左ドラッグでスクロール

    onMouseDownLeft(e) {
      this.beginDragScroll(e)
    },

    onCellMouseDownLeft(e) {
      this.selectCell(e)
      this.beginDragScroll(e)
    },

    // キー押下

    onKeyDown(e) {
      if(this.processKeyDown(e)) {
        return
      }

      // 削除 (Backspace/Deleteキー押下)
      if(e.key === 'Backspace' || e.key === 'Delete') {
        if(!this.isEditing) {
          this.callTyped('delete')
          e.preventDefault()
        }
        return
      }
    },

    // 編集開始 (cell領域をダブルクリック, Enterキー押下)

    onCellDoubleClick(e) {
      this.selectCell(e)
      this.callTyped('beginEdit')
    },

    onPressEnterBeginEdit() {
      this.callTyped('beginEdit')
    },

    // コピー/ペースト

    onClipboardCopy() {
      this.callTyped('clipboardCopy')
    },

    onClipboardPaste() {
      this.callTyped('clipboardPaste')
    },

    // cell領域のコンテキストメニュー
    onCellContext(e, options) {
      this.selectCell(e)
      options([{
        label: '編集', onClick: () => {
          this.callTyped('beginEdit')
        },
      }])
    },

    //-------------------------------------------------------------------------
    // 個人マスターの編集 (rowヘッダをダブルクリック)

    onRowHeaderDoubleClick(e) {
      const {y} = this.getCellPosition(e)
      this.grid.cursor = {x: 0, y}
      const weekly_task = this.weekly_tasks[y]
      this.detailShow(weekly_task)
    },

    detailShow(weekly_task = {}) {
      this.$refs.detail.show(this.people, this.tasks, weekly_task)
    },

    async detailConfirm(data) {
      try {
        if(data.id) {
          const {y} = this.grid.cursor
          await this.updateWeeklyTask(data, y)
        }
        else {
          await this.createWeeklyTask(data)
        }
        this.$refs.detail.hide()
      }
      catch(e) {this.$refs.detail.handler(e)}
    },

    async detailDelete(data) {
      try {
        await this.destoryWeeklyTask(data)
        this.$refs.detail.hide()
      }
      catch(e) {this.$refs.detail.handler(e)}
    },

    //-------------------------------------------------------------------------

    // 出勤退勤時刻の編集開始

    beginEditTime() {
      const {x, y} = this.grid.cursor
      const weekly_task = this.weekly_tasks[y]

      const person = this.personMap[weekly_task.person_code]
      const task = this.taskMap[weekly_task.task_code]
      const week = this.cols[x].week

      const begin_time = weekly_task['begin_time_' + (x - 1)]
      const end_time = weekly_task['end_time_' + (x - 1)]

      const people_begin = person['begin_time_' + (x - 1)]
      const people_end = person['end_time_' + (x - 1)]
      const notice = (people_begin !== '' && people_end !== '')
        ? `勤務予定 - ${timeFilter(people_begin)}～${timeFilter(people_end)}`
        : `勤務予定 - 休み`

      this.$refs.popupTimeRange.show(begin_time, end_time, {
        title: `${person.name} - ${task} - ${weeks[week].long}`,
        notice, x, y
      })
    },

    // 出勤退勤時刻の削除

    deleteTime() {
      const {x, y} = this.grid.cursor
      this.timeRangeConfirm('', '', {x, y})
    },

    // 出勤退勤時刻の編集終了

    async timeRangeConfirm(begin_time, end_time, {x, y}) {
      try {
        const weekly_task = this.weekly_tasks[y]

        await this.updateWeeklyTask({
          id: weekly_task.id,
          ['begin_time_' + (x - 1)]: begin_time,
          ['end_time_'   + (x - 1)]: end_time,
        }, y)
        this.$refs.popupTimeRange.hide()
      }
      catch(e) {this.$handler(e)}
    },

    // 出勤退勤時刻のコピー/ペースト

    clipboardCopyTime() {
      const {x, y} = this.grid.cursor
      const weekly_task = this.weekly_tasks[y]
      const begin_time = weekly_task['begin_time_' + (x - 1)]
      const end_time = weekly_task['end_time_' + (x - 1)]
      this.clipboard = {begin_time, end_time}
    },

    async clipboardPasteTime() {
      try {
        if('begin_time' in this.clipboard &&
           'end_time'   in this.clipboard) {

          const {x, y} = this.grid.cursor
          const weekly_task = this.weekly_tasks[y]

          await this.updateWeeklyTask({
            id:                        weekly_task.id,
            ['begin_time_' + (x - 1)]: this.clipboard.begin_time,
            ['end_time_'   + (x - 1)]: this.clipboard.end_time,
          }, y)
        }
      }
      catch(e) {this.$handler(e)}
    },

    //-------------------------------------------------------------------------

    // グループの編集開始

    beginEditTask() {
      const {y} = this.grid.cursor
      const weekly_task = this.weekly_tasks[y]
      this.detailShow(weekly_task)
    },

    //-------------------------------------------------------------------------

    callTyped(method, ...args) {
      const {x} = this.grid.cursor
      method += this.cols[x].type
      if(method in this) {
        this[method](...args)
      }
    },

  },
}
</script>
